<template>
    <div class="university-show md:container">
        <Breadcrumbs
            :breadcrumbs="breadcrumbs"
            class="max-md:container"
        />

        <UniversityShowHeader :university="university" />

        <TabsPanel
            :model-value="params.content ?? 'courses'"
            no-url
            class="mx-auto py-5"
            panel-list-class="mb-5"
            @update:model-value="onTabChange"
        >
            <TabsPanelTab
                id="courses"
                :name="t('tab_courses', { count: coursesTotalCount })"
            >
                <UniversityShowCourses></UniversityShowCourses>
            </TabsPanelTab>
            <TabsPanelTab
                id="documents"
                :name="t('tab_documents', { count: documentsTotalCount })"
            >
                <UniversityShowDocuments></UniversityShowDocuments>
            </TabsPanelTab>
        </TabsPanel>
        <TheFooterStatic class="mt-5" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@components/Breadcrumbs';
import TabsPanel from '@components/TabsPanel';
import TabsPanelTab from '@components/TabsPanelTab';
import TheFooterStatic from '@components/TheFooterStatic';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';
import { getUniLink } from '@/router/links';
import UniversityShowHeader from './UniversityShowHeader.vue';
import UniversityShowCourses from './UniversityShowCourses.vue';
import UniversityShowDocuments from './UniversityShowDocuments.vue';

export default {
    name: 'UniversityShow',
    components: {
        TheFooterStatic,
        Breadcrumbs,
        UniversityShowHeader,
        TabsPanel,
        TabsPanelTab,
        UniversityShowDocuments,
        UniversityShowCourses,
    },
    setup() {
        const { t } = useTranslation('university');
        return { t };
    },
    data: () => ({
        university: window.sdWindow.university,
    }),
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
            locale: 'ui/getLocale',
            params: 'university/searchParams',
            coursesTotalCount: 'university/coursesTotalCount',
            documentsTotalCount: 'university/documentsTotalCount',
        }),
        universityBreadCrumb() {
            if (this.locale === 'de') {
                return 'Unis';
            }
            return 'Universities';
        },
        breadcrumbs() {
            return [
                {
                    title: this.universityBreadCrumb,
                    link: route('universities.search'),
                },
                {
                    title: this.university.name,
                    link: getUniLink(this.university.id, this.university.name),
                },
            ];
        },
    },
    created() {
        this.$store.dispatch('university/setCurrentUniversity', this.university);
    },
    methods: {
        onTabChange(tabId) {
            if (this.params.content === tabId) return;

            this.$store.dispatch('university/applyParams', {
                p: 1,
                content: tabId,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.university-show:deep(.search-field input) {
    @apply bg-white;
}
</style>
